import { createDiscount, updateDiscount as editDiscount, getFilteredPolicies } from '../utils/apiService';

export const CREATE_DISCOUNT = 'discount/CREATE_DISCOUNT';
export const CREATE_DISCOUNT_PENDING = 'discount/CREATE_DISCOUNT_PENDING';
export const CREATE_DISCOUNT_FULFILLED = 'discount/CREATE_DISCOUNT_FULFILLED';
export const CREATE_DISCOUNT_REJECTED = 'discount/CREATE_DISCOUNT_REJECTED';

export const LIST_DISCOUNTS = 'discount/LIST_DISCOUNTS';
export const LIST_DISCOUNTS_PENDING = 'discount/LIST_DISCOUNTS_PENDING';
export const LIST_DISCOUNTS_REJECTED = 'discount/LIST_DISCOUNTS_REJECTED';
export const LIST_DISCOUNTS_FULFILLED = 'discount/LIST_DISCOUNTS_FULFILLED';

export const SET_DISCOUNT = 'discount/SET_DISCOUNT';
export const SET_DISCOUNT_PENDING = 'discount/SET_DISCOUNT_PENDING';
export const SET_DISCOUNT_FULFILLED = 'discount/SET_DISCOUNT_FULFILLED';
export const SET_DISCOUNT_REJECTED = 'discount/SET_DISCOUNT_REJECTED';


export const saveDiscount= (discount) => {
    const payload = createDiscount(discount);
    return {
        type: CREATE_DISCOUNT,
        payload
    }
}

export const updateDiscount = (discount) => {
    const payload = editDiscount(discount);
    return {
        type: SET_DISCOUNT,
        payload
    }
}

export const listDiscounts = () => {
    const payload = getFilteredPolicies({
        is_discount: true
    });

    return {
        type: LIST_DISCOUNTS,
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/discounts.js